import { Routes, Route } from "react-router-dom";

// pages
import About from "../../pages/dashboard/about/About";

const AboutRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<About />} />
    </Routes>
  );
};
export default AboutRoutes;
